import { consumer, core, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  business?: consumer.IBusinessConfig;
  config?: consumer.ConsumerConfig;
  questions?: core.TicketTypeQuestion[];
  requestInProgress: boolean;
}

const initialState: State = {
  business: undefined,
  config: undefined,
  questions: undefined,
  requestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.BUSINESS_FETCH_DONE: {
      const consumerConfig = payloadToJSON<consumer.ConsumerConfig>(payload);
      return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        business: consumerConfig.business!,
        config: consumerConfig,
        requestInProgress: false,
      };
    }
    case AppConstants.BUSINESS_CLEAR: {
      return {
        ...state,
        business: undefined,
        config: undefined,
        requestInProgress: false,
      };
    }

    default:
      return state;
  }
}
